var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaBackwardStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2.625V7.9375L12.2031 2.27344C12.3984 2.11719 12.6328 2 12.9062 2C13.4922 2 14 2.50781 14 3.09375V15.9453C14 16.5312 13.4922 17 12.9062 17C12.6328 17 12.3984 16.9219 12.2031 16.7656L5.25 11.1016V16.375C5.25 16.7266 4.9375 17 4.625 17C4.27344 17 4 16.7266 4 16.375V10.0859V8.95312V2.625C4 2.3125 4.27344 2 4.625 2C4.9375 2 5.25 2.3125 5.25 2.625ZM12.75 3.44531L5.28906 9.5L12.75 15.5938V3.44531Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaBackwardStepIcon);
export default __webpack_public_path__ + "static/media/faBackwardStepIcon.e84da8a61111fdaefc5b2c4e8f531fb3.svg";
export { ForwardRef as ReactComponent };